// extracted by mini-css-extract-plugin
export default {"container":"loader_container__ngq9p","text":"loader_text__D6ddS"};